import { render, staticRenderFns } from "./addManage.vue?vue&type=template&id=63815f41&"
import script from "./addManage.vue?vue&type=script&lang=js&"
export * from "./addManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63815f41')) {
      api.createRecord('63815f41', component.options)
    } else {
      api.reload('63815f41', component.options)
    }
    module.hot.accept("./addManage.vue?vue&type=template&id=63815f41&", function () {
      api.rerender('63815f41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/eventmanagement/eventList/component/addManage.vue"
export default component.exports